import React, { useEffect, useRef } from 'react'
import { IRoute } from '../../core/interfaces/Menu';
import SubMenu from './SubMenu'
import SimpleMenu from './SimpleMenu'

export default (props: IRoute, index) => props.data ? <SubMenu key={props.label} {...props} level={props.level + 1} /> : <SimpleMenu key={props.label}  {...props} level={props.level + 1} />
